
import { Image } from 'utils'
import { TYPE } from 'network/network_api'
import { REQUEST_TYPE } from 'network/net'

export default function( space, container, settings )
{
    const COLOR = 0xf2e200

    const bottom_left = new PIXI.Text(
        '',
        {
            fontSize : 18,
            fill : COLOR,
            align : 'center',
            fontStyle: 'italic',
            wordWrap : true,
            wordWrapWidth : 420,
        },
    )

    const $toState = space.s('double_state', {});
    space.s('state').to($toState);
    const $statePair = $toState.pairwise();

    bottom_left.anchor.set( 0.5 )
    bottom_left.position.set( 241, 805 )
    container.addChild( bottom_left )
    $statePair
        .filter( ([prevState, currentState]) => currentState.type == TYPE.FINAL )
        .on( ([prevState, currentState]) => {
            if (prevState && prevState.state && prevState.state.open_win <= 0) {
                bottom_left.text =  'Вам еще повезет. Выполните следующий шаг'
            }
            else {
                bottom_left.text = 'Делайте следующий шаг'
            }
        } );
    space.s( 'request' )
        .filter( r => r.type == REQUEST_TYPE.SPIN )
        .on( () => bottom_left.text = 'Шаг выполнен' )
    space.s( 'state' )
        .filter( state => state.type == TYPE.FREESPIN )
        .on( state => bottom_left.text = '%d из %d доступных шагов'.$( state.state.stage.math.currentFreeGameNumber, state.state.stage.math.freeGamesCount ) )
    space.s( 'ui:riskInvitation' )
        .filter( ri => ri )
        .on( () => {
            bottom_left.text = 'Шаг засчитан';
        } )
    space.s( 'ui:riskInvitation' )
        .delay(2000)
        .filter(ri => ri)
        .with(space.s('state') , (ri, state) => state)
        .filter(state => state.type == TYPE.REGULAR)
        .on(() => bottom_left.text = 'Если желаете принять участие в пари по правилам «Экспресс Bet» нажмите кнопку "АВТО/ЭКСПРЕСС"')
    
    
    const right_regular = Image( settings.texts.imgMain )
    right_regular.position.set( settings.texts.posMain.x, settings.texts.posMain.y )
    container.addChild( right_regular )
    space.s( 'isRisk' ).on( ir => right_regular.visible = ! ir )
    
    const right_risk = Image( settings.texts.imgRisk )
    right_risk.position.set( settings.texts.posRisk.x, settings.texts.posRisk.y )
    container.addChild( right_risk )
    space.s( 'isRisk' ).on( ir => right_risk.visible = ir )
}






// WEBPACK FOOTER //
// ./src/games/texts.es6